export var EncoderTypes;
(function (EncoderTypes) {
    EncoderTypes["ACTION"] = "ACTION";
    EncoderTypes["METRICS"] = "METRICS";
    EncoderTypes["SFU_MESSAGE"] = "SFU_MESSAGE";
    EncoderTypes["MAJOR_EVENT"] = "MAJOR_EVENT";
    EncoderTypes["CONSOLE_MESSAGE"] = "CONSOLE_MESSAGE";
    EncoderTypes["PLAYER_INFO"] = "PLAYER_INFO";
    EncoderTypes["SELF_INFO"] = "SELF_INFO";
    EncoderTypes["DEVICES_CHANGED"] = "DEVICES_CHANGED";
    EncoderTypes["SELECTED_DEVICE_CHANGED"] = "SELECTED_DEVICE_CHANGED";
    EncoderTypes["STATE_MACHINE_TRANSITION"] = "STATE_MACHINE_TRANSITION";
    EncoderTypes["WEBRTC_ISSUE"] = "WEBRTC_ISSUE";
    EncoderTypes["TRACKER_ENCODING_ERROR"] = "TRACKER_ENCODING_ERROR";
    EncoderTypes["NETWORK_TEST_RESULTS"] = "NETWORK_TEST_RESULTS";
})(EncoderTypes || (EncoderTypes = {}));
//# sourceMappingURL=types.js.map